// A one-line pointer to the referral program where someone has just made
// something worth sharing: under a finished cover (conversion Result, owner
// view) and on their own voice page. With a code it says their share links
// already carry it (lib/referral/share) and links their earnings; without,
// it links the join flow. Signed-out visitors see nothing.
import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { useT } from "@jammable/ui-core/src/i18n";
import { useAuth } from "../../context/AuthProvider";
import { track } from "../../utils/analytics";
import { normalizeReferralCode } from "../../lib/referral/code";

// Message keys in packages/ui/core/src/i18n/messages/referral.ts.
const COPY = {
  cover: {
    without: "referral.nudge.coverNoCode",
    with: "referral.nudge.coverWithCode",
  },
  voice: {
    without: "referral.nudge.voiceNoCode",
    with: "referral.nudge.voiceWithCode",
  },
} as const;

export default function EarnNudge({
  where,
  className = "",
}: {
  where: keyof typeof COPY;
  className?: string;
}) {
  const { user } = useAuth() as {
    user?: { referralCode?: string | null } | null;
  };
  const t = useT();
  if (!user) return null;
  const code = normalizeReferralCode(user.referralCode);
  const href = code ? "/earn" : "/earn/join";
  return (
    <a
      href={href}
      onClick={() =>
        track("Earn Nudge Clicked", { where, hasCode: !!code }).catch(
          () => undefined,
        )
      }
      className={`tw-flex tw-items-center tw-gap-3 tw-rounded-[20px] tw-bg-jam-ink tw-px-4 tw-py-3 tw-text-white tw-no-underline tw-transition-transform hover:tw-scale-[1.01] ${className}`}
    >
      <span className="tw-flex tw-h-8 tw-w-8 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-jam-lime tw-text-jam-ink">
        <Sparkles size={16} strokeWidth={2.6} />
      </span>
      <span className="tw-min-w-0 tw-flex-1 tw-text-[14px] tw-font-bold tw-leading-snug">
        {t(COPY[where][code ? "with" : "without"])}
      </span>
      <span className="tw-flex tw-shrink-0 tw-items-center tw-gap-1 tw-text-[13px] tw-font-extrabold tw-text-jam-lime">
        {t(code ? "referral.nudge.earnings" : "referral.nudge.getCode")}
        <ArrowRight size={15} strokeWidth={2.8} />
      </span>
    </a>
  );
}
